import cn from 'classnames';
import React, { useCallback, useImperativeHandle, useState } from 'react';

import { createChainedFunction } from 'utils/functions';
import EmbedPlayer, {
  EmbedPlayerInstance,
  EmbedPlayerProps,
} from './EmbedPlayer';
import { block } from './utils';

export type EmbedPreviewInstance = {
  embedPlayer: EmbedPlayerInstance;
};

export type EmbedPreviewProps = EmbedPlayerProps;

const EmbedPreview = React.forwardRef<EmbedPreviewInstance, EmbedPreviewProps>(
  ({ className, lastPlaybackPos, onDestroy, onSeeked, src, ...props }, ref) => {
    const [player, setPlayer] = useState<EmbedPlayerInstance>();
    const [fallbackLastPlaybackPos, setFallbackLastPlaybackPos] = useState<
      number
    >();

    const handleSeeked = useCallback((_: number) => {
      setFallbackLastPlaybackPos(undefined);
    }, []);

    useImperativeHandle(
      ref,
      () => ({
        embedPlayer: player,
      }),
      [player],
    );

    return (
      <EmbedPlayer
        className={cn(block(), className)}
        ref={setPlayer}
        key={src}
        src={src}
        onDestroy={createChainedFunction(setFallbackLastPlaybackPos, onDestroy)}
        onSeeked={createChainedFunction(handleSeeked, onSeeked)}
        lastPlaybackPos={lastPlaybackPos ?? fallbackLastPlaybackPos}
        {...props}
      />
    );
  },
);

export default EmbedPreview;
